module.exports = __webpack_public_path__ + "img/14-pc-hero.d34b8e50.webp";